// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Zl3aQ","question":"styles_question__EiXKS","button":"styles_button__sfYGY"};